import React from "react";

type LatestNumberProps = {
  data?: any;
  isMobile?: boolean;
};
const LatestNumber: React.FC<LatestNumberProps> = ({ data  }) => {
  const numbers = data?.numbers;
  return (
    <section className="relative bg-background-white text-primary-text py-[56px] xl:py-[100px] md:py-[83px] overflow-hidden">
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-start justify-start mx-auto">
          <div className="grid md:grid-cols-12 gap-6 md:gap-[30px] items-center w-full">
            <div className="sm:text-left xl:col-span-12 md:col-span-12">
              <h2 className="text-heading-1 font-bold text-primary-text text-center mb-[32px] xl:mb-[40px] md:mt-[-0]">
                {data?.title}
              </h2>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-12 md:gap-[30px] gap-[24px] w-full">
            {numbers.map((item: any, index: number) => (
              <div
                key={index}
                className={`
                  bg-white w-full icon-container overflow-hidden 
                  col-span-4 ${index % 2 === 1 ? "bg-[url('/images/manufacturing/green-noise.png')]" : "bg-[url('/images/manufacturing/blu-noise.png')]"} 
                  bg-cover bg-center bg-no-repeat   min-h-[187px] md:min-h-[230px] xl:min-h-[291px]
                  max-h-[187px] md:max-h-[230px] xl:max-h-[291px] xl:p-[32px] p-[32px_0_32px_0] 
                  xl:border-t-4 border-t-2 xl:border-b-4 border-b-2 ${index % 2 === 1 ? "border-green-500" : "border-blue-500"}  
                  transition-shadow duration-300
                `}
              >
                <div className="text-center">
                  <div
                    className={`font-extrabold text-[#18A342] mb-0 text-display ${index % 2 === 1 ? "text-green-900" : "text-blue-900"}`}
                  >
                    {item?.number}
                  </div>
                  <div className="text-subtitle-3 font-semibold text-primary-text mb-[16px] xl:mb-[32px]">
                    {item?.title}
                  </div>
                  <p className="text-primary-text text-subtitle-3 leading-relaxed mb-0 max-[259px]">
                    {item?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default LatestNumber;
